import { VARIANT } from "@super-ui/components/cart-upsell-nudge/Components/PlanRemoveConfirmationBottomsheetWrapper/constants";
import {
    getPrimaryCTA,
    getSecondaryCTA,
} from "@super-ui/components/cart-upsell-nudge/Components/PlanRemoveConfirmationBottomsheetWrapper/helpers";
import { GRATIFICATION_POPUP_PLAN_NAMES } from "@super-ui/constants";
import { ProgramSubTypes } from "@super-ui/interfaces";
import { IRemovePlanMessage } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/js-utils";

export const getPlanName = (planType?: string) => {
    if (planType === ProgramSubTypes.PLUS) {
        return GRATIFICATION_POPUP_PLAN_NAMES.PLUS;
    } else if (planType === ProgramSubTypes.LITE) {
        return GRATIFICATION_POPUP_PLAN_NAMES.LITE;
    } else if (planType === ProgramSubTypes.BLACK) {
        return GRATIFICATION_POPUP_PLAN_NAMES.BLACK;
    }
    return "";
};

export const getCTA = ({
    removePlanMessage,
    hasSignificantCartDifference,
    planType,
    bottomsheetCtaTexts,
}: {
    removePlanMessage: IRemovePlanMessage;
    hasSignificantCartDifference: boolean;
    planType: string;
    bottomsheetCtaTexts: {
        PRIMARY: string;
        SECONDARY: string;
    };
}) => {
    let primaryCTA = "";
    let secondaryCTA = "";
    if (!isEmpty(removePlanMessage) && removePlanMessage.variant === VARIANT.ANIMATION) {
        primaryCTA = getPrimaryCTA(
            hasSignificantCartDifference,
            removePlanMessage.attribute_values.plan_in_cart_savings,
            planType,
        );
        secondaryCTA = getSecondaryCTA(hasSignificantCartDifference, planType);
    } else {
        primaryCTA = bottomsheetCtaTexts.PRIMARY;
        secondaryCTA = bottomsheetCtaTexts.SECONDARY;
    }
    return { primaryCTA, secondaryCTA };
};
